export const DEVICE_SCHEMA_DETAILS_PATH =
  "config/api/v1/devices/schemas/details/nc12/{nc12}/v/{version}";
export const DEVICE_SEARCH_ENDPOINT = "search/api/v1/search/v1/devices";
export const DEVICE_STATUS_ENDPOINT = "http://localhost:2020/server/v1/status";
export const DEVICE_SEARCH_QUERY_PREFIX = "?query=nc12%3A*";
export const DEVICE_ARCHIVE_QUERY_SUFFIX = "&showArchive=true";

export const DEFAULT_DEVICE_REGIONS: ReadonlyArray<string> = [
  "EMEA",
  "NA",
  "CN",
  "ROA",
];

export const PRIMARY_DEVICE_REGIONS: ReadonlyArray<string> = ["EMEA", "NA"];

export const LUMINAIRE_FEATURE_VALUES: ReadonlyArray<string> = [
  "AOC",
  "CLO",
  "DTL",
  "MTP",
];

export const LIGHT_CONTROL_FEATURE_VALUES: ReadonlyArray<string> = [
  "ALO",
  "Dynadim",
];

export const LUMINAIRE_INFO_FEATURE_VALUES: ReadonlyArray<string> = [
  "Luminaire Info",
];

export const CONFIGURATION_MODES: ReadonlyArray<string> = [
  "Advanced",
  "Standard",
];

export const DEFAULT_CONFIGURATION_MODE = "Advanced";
export const STANDARD_CONFIGURATION_MODE = "Standard";

export const EASY_DESIGN_API_DOMAIN = "https://www.api.easydesignintool.signify.com";
